import { Skeleton, Stack, Group, Paper, Box, Table } from '@mantine/core';
import { isMobile } from 'react-device-detect';

export default function InboxSkeletonLoader() {
  if (isMobile) {
    return (
      <Stack gap="xs" w="100%" p="xs">
        {[1, 2, 3, 4, 5].map((item) => (
          <Paper key={item} shadow="xs" p="md" radius="md" withBorder>
            <Group gap="md" align="flex-start">
              <Skeleton height={40} width={40} circle />
              <Stack gap="xs" style={{ flex: 1 }}>
                <Skeleton height={14} width="70%" radius="sm" />
                <Skeleton height={12} width="50%" radius="sm" />
                <Skeleton height={12} width="60%" radius="sm" />
              </Stack>
            </Group>
          </Paper>
        ))}
      </Stack>
    );
  }

  return (
    <Box data-testid="comhub-loader" w="100%">
      <Table>
        <Table.Tbody>
          {[1, 2, 3, 4, 5].map((item) => (
            <Table.Tr key={item}>
              <Table.Td w="20%">
                <Skeleton height={14} width="90%" radius="sm" />
              </Table.Td>
              <Table.Td w="18%">
                <Skeleton height={14} width="85%" radius="sm" />
              </Table.Td>
              <Table.Td w="18%">
                <Skeleton height={14} width="80%" radius="sm" />
              </Table.Td>
              <Table.Td w="20%">
                <Skeleton height={14} width="75%" radius="sm" />
              </Table.Td>
              <Table.Td w="14%">
                <Skeleton height={14} width="85%" radius="sm" />
              </Table.Td>
              <Table.Td w="10%" style={{ textAlign: 'right' }}>
                <Skeleton height={14} width="70%" radius="sm" ml="auto" />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
}
